<template>
  <div class="events-section">
    <Loading :active="isLoading" :can-cancel="false" :is-full-page="false" />
    <div class="details box is-radiusless is-marginless is-shadowless">
      <h4 class="is-size-5">Projektfiler</h4>
      <file-tags-list
        :files="projectFiles"
        :max_tags="maxProjectFiles"
      ></file-tags-list>
      <file-modal
        v-if="show_modal"
        @CLOSEMODAL="toggle_modal"
        :show="show_modal"
        active_panel="scope_project"
      >
      </file-modal>
      <div>
        <label class="button is-primary" for="file">
          <b-icon icon="upload" style="margin-right: 0.5rem;" />Upload
          fil</label
        >
        <input
          type="file"
          id="file"
          ref="file"
          style="display: none"
          v-on:change="fileFieldChange($event)"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '../../../../global/styles/variables';
</style>

<script>
import Loading from 'vue-loading-overlay'
import Avatar from '@/taskflex/users/components/Avatar'
import FileTagsList from '@/infrastructure/fileuploads/components/FileTagsList'
import FileModal from '@/infrastructure/fileuploads/components/FileModal'

import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ProjectAttachments',
  components: {
    Avatar,
    FileTagsList,
    FileModal,
    Loading
  },
  props: {
    project: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      file: null,
      projectId: null,
      show_modal: false,
      files: {
        project: null
      }
    }
  },
  computed: {
    ...mapGetters('fileuploads', [
      'allFiles',
      'projectFiles',
      'maxProjectFiles',
      'isLoading'
    ])
  },
  methods: {
    ...mapActions('fileuploads', [
      'getAllFiles',
      'getProjectFiles',
      'uploadFile',
      'setIsLoading'
    ]),
    fileFieldChange () {
      this.setIsLoading(true);
      const file = this.$refs.file.files[0]

      this.projectId = this.project.id

      this.uploadFile({
        file,
        projectId: this.projectId
      })
        .then(() => {
          this.setIsLoading(false);
          this.$buefy.toast.open({
            message: `Filen er blevet uploaded`,
            type: 'is-success',
            duration: 5000
          })
        })
        .catch(() => {
          this.setIsLoading(false);
          this.$buefy.toast.open({
            message: 'Noget gik galt under upload af fil.',
            type: 'is-danger',
            duration: 5000
          })
        })
    },
    toggle_is_loading () {
      this.is_loading = !this.is_loading
    },
    toggle_modal () {
      this.show_modal = !this.show_modal
    },
    loadProjectFiles () {
      this.getProjectFiles(this.project.id)
        .then(() => {
          this.setIsLoading(false);
        })
        .catch(() => {
          this.setIsLoading(false);
        })
    }
  },
  mounted () {
    this.setIsLoading(true);
    this.loadProjectFiles()
    // join project-event-channel 'projects.ID.actions'
    // join project-event-channel 'projects.ID.events'
  }
}
</script>



// WEBPACK FOOTER //
// src/taskflex/conversations/components/Projects/ProjectAttachments.vue